import React from 'react';
import {
  Form, FormHandlers, FormProps, SelectOption,
} from '@doveit/bricks';
import { TaskPriority, TaskType } from '../../../domain/types';
import { asSelectOptions } from '../../../select-options/utils/asSelectOptions';
import { taskTypeLabels } from '../../../labels';
import { taskValidationSchema } from './TaskForm.schema';

export interface TaskFormModel {
  type: TaskType,
  title: string,
  description: string,
  priority: TaskPriority,
  assignee: string,
}

export interface TaskFormProps {
  initialValues?: Partial<TaskFormModel>,
  innerRef?: React.MutableRefObject<FormHandlers>,
  loading?: FormProps<TaskFormModel>['loading'],
  showAssignee?: boolean,
  assignees?: SelectOption[],
  onSubmit: FormProps<TaskFormModel>['onSubmit'],
}

export const TASK_FORM_DEFAULT_VALUES: TaskFormModel = {
  type: TaskType.OTHER,
  title: '',
  description: '',
  priority: TaskPriority.MEDIUM,
  assignee: '',
};

const TaskForm: React.FC<TaskFormProps> = ({
  initialValues,
  innerRef,
  showAssignee = false,
  assignees = [],
  ...rest
}) => {
  const mergedInitialValues: TaskFormModel = React.useMemo(() => ({
    ...TASK_FORM_DEFAULT_VALUES,
    ...initialValues,
  }), [initialValues]);

  return (
    <Form
      initialValues={mergedInitialValues}
      innerRef={innerRef}
      validationSchema={taskValidationSchema}
      {...rest}
    >
      <Form.Item size={{ MD: 1 / 2 }}>
        <Form.Select
          name="type"
          label="Tipologia"
          aria-label="Campo per specificare la tipologia dell'attività"
          options={asSelectOptions(taskTypeLabels, false)}
          hasErrorTooltip
          required
        />
      </Form.Item>

      <Form.Item>
        <Form.Input
          name="title"
          label="Titolo"
          aria-label="Campo per specificare il titolo dell'attività"
          hasErrorTooltip
          required
        />
      </Form.Item>

      <Form.Item>
        <Form.TextArea
          label="Descrizione"
          aria-label="Campo per inserire la descrizione dell'attività"
          name="description"
          rows={2}
        />
      </Form.Item>

      {showAssignee && assignees.length > 0 && (
        <Form.Item size={{ MD: 1 / 2 }}>
          <Form.Select
            name="assignee"
            label="Assegnatario"
            aria-label="Campo per specificare l'assegnatario dell'attività"
            options={assignees}
          />
        </Form.Item>
      )}
    </Form>
  );
};

export default TaskForm;
